import { useEffect, useState, useRef } from 'react';
import './index.scss';
import { NavBar, PullToRefresh, Skeleton } from 'antd-mobile';
import http from '../../utils/request';
import { useNavigate } from 'react-router-dom';
import newImg from '../../common/img/new.png';
export default function Album() {
  const [queryData, setQueryData] = useState<any[]>([]); // 查询到的数据
  const [loading, setLoading] = useState(true); // 加载状态
  const navigate = useNavigate();
  const PAGE_SIZE = 100; // 固定数据大小
  useEffect(() => {
    queryFunc(); // 初始化加载数据
  }, []);

  // 查询数据的函数
  const queryFunc = async () => {
    try {
      setLoading(true);
      const res = await http.get<any, any>('album/query?userState=0', { params: { page: 1, size: PAGE_SIZE } });
      if (res.code === 0) {
        const newData = res.data.map((element: { imgUrl: string; video: string }) => ({
          ...element,
          imgUrl: JSON.parse(element.imgUrl),
          video: JSON.parse(element.video),
        }));

        setQueryData(newData); // 直接更新数据
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  // 下拉刷新的函数
  const handleRefresh = async () => {
    await queryFunc(); // 重新加载数据
  };

  // 跳转到 AlbumDetails 页面
  const goToDetails = (item: any) => {
    navigate('/albumDetails', { state: { item } });
  };

  return (
    <div className="album">
      <div className="xcBox">
        <NavBar onBack={() => navigate(-1)}>相册</NavBar>
      </div>
      <PullToRefresh onRefresh={handleRefresh}>
        <div className="album_contentBox" style={{ height: 'calc(100vh - 100px)' }}>
          {loading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <div className="contentItem skeleton" key={index}>
                <Skeleton animated style={{ width: '100%', height: '180px', marginBottom: '10px' }} />
                <Skeleton animated style={{ width: '60%', height: '20px' }} />
              </div>
            ))
          ) : (
            queryData.map((item: any, index: number) => (
              <div className="contentItem" key={index} onClick={() => goToDetails(item)}>
                <img className='ptImg' src={'http://175.27.130.210:8091' + item.imgUrl[0]} alt="" />
                {item.isItNew == 1 && <img src={newImg} className='xrimg' alt="" />}
                <div className="title">{item.title}</div>
              </div>
            ))
          )}
        </div>
      </PullToRefresh>
    </div>
  );
}
